import {
  Badge,
  createListCollection,
  Field,
  HStack,
  Icon,
  Input,
  Portal,
  Select,
  Table,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateWithdrawStatus, withdrawalList } from "../Redux/Action";
import { WithdrawalSkeleton } from "../Components/custom/Skeletons/WithdrawalSkeleton";
import { formatDateTime } from "../Utils/newHelper";
import { FaInfoCircle } from "react-icons/fa";
import { CustomPagination } from "../Components/custom/CustomPagination";
import withBankInfo from "../Hocs/withBankInfo";
import InfoModal from "../Components/custom/InfoModal";
import withCryptoInfo from "../Hocs/withCryptoInfo";
import ActionButtonGroup from "../Components/custom/ActionButtonGroup";
import DateRangeFilter from "../Components/custom/DateRangeFilter";
import { getLocalStorageItem, notifyPromise } from "../Utils/Helper";
import {ADD_BALANCE_PARAMS} from "../Utils/Constants";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";
import { ExternalWithdrawalInfoModal } from "../Components/custom/ExternalWithdrawalInfoModal";
import API from "../Utils/api";
const BankInfoModal = withBankInfo(InfoModal);
const CryptoInfoModal = withCryptoInfo(InfoModal);

export const WithdrawalRequests = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Withdrawal Requests");
  }, []);

  const statuses = createListCollection({
    items: [
      { label: "Pending", value: "pending" },
      { label: "Rejected", value: "rejected" },
      { label: "Accepted", value: "accepted" },
    ],
  });

  const dispatch = useDispatch();
  const [allWithdrawals, setAllWithdrawals] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [copiedId, setCopiedId] = useState(null);
  const [transactionType, setTransactionType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalData, setModalData] = useState(null);
  const now = new Date();
  const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const [from, setFrom] = useState(formatDate(oneDayAgo));
  const [to, setTo] = useState(formatDate(now));
  const [status, setStatus] = useState("pending");
  const [isDisabled, setIsDisabled] = useState(false);
  const whitelabelData = getLocalStorageItem("whitelabelData")
  const today = now.toISOString().split("T")[0];
  const thirtyOneDaysAgo = new Date(now.getTime() - 31 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];

  function formatDate(date) {
    return date.toISOString().split("T")[0];
  }

  useEffect(() => {
    const payload = {
      ...(whitelabelData?._id != null && { whitelabelId: whitelabelData._id }),
      date_from: from,
      date_to: to,
      per_page: 10,
      page: currentPage,
      currency: "USD",
      ...(status && { status }),
    };
    dispatch(
      withdrawalList({
        payload,
        callback: (data) => {
          if (data?.meta?.code === 200) {
       
            setAllWithdrawals(data?.data?.data);
            setTotalPages(data?.data?.pagination?.totalPages);
            setisDataLoading(false);
          }
        },
      })
    );
  }, [currentPage, from, to, status]);

  const handleCopy = (orderNumber) => {
    navigator.clipboard.writeText(orderNumber);
    setCopiedId(orderNumber);
    setTimeout(() => {
      setCopiedId(null);
    }, 1000);
  };

  const onAction = (type, _id) => {
    setIsDisabled(true);

    const payload = {
      id: _id,
      type,
    };
    dispatch(
      updateWithdrawStatus({
        payload,
        callback: (data) => {
          setIsDisabled(false);
          if (data?.meta?.code === 200) {
            setAllWithdrawals((prev) => prev.filter((item) => item._id !== _id));
          }
        },
      })
    );
  };

  const onExternalAction = async (type, _id) => {
    setIsDisabled(true);
    try {
      const { data } = await notifyPromise(
        API.get(`/external-withdrawal-accept-reject?_id=${_id}&type=${type}&paramsType=${ADD_BALANCE_PARAMS}`),
        type === "accept" ? "Accepting..." : "Rejecting..."
      );
      if (data?.meta?.code === 200) {
        setAllWithdrawals((prev) => prev.filter((item) => item._id !== _id));
      }
    } catch (error) {
      // notifyPromise already shows the error toast
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <VStack>
      <HStack width="100%" justifyContent="space-between">
        <DateRangeFilter
          initialFrom={from}
          initialTo={to}
          onApply={({ from, to }) => {
            setFrom(from);
            setTo(to);
          }}
          isLoading={isDataLoading}
        />
        <HStack width="30%" justifyContent="flex-end" spacing={4}>
          <Select.Root
            collection={statuses}
            width="100%"
            disabled={isDataLoading}
            onValueChange={(details) => {
              setStatus(details.value[0]);
              setCurrentPage(1);
            }}
            value={[status]} // Value should be an array
            defaultValue={["pending"]}
          >
            <Select.HiddenSelect />
            <Select.Label>Select Status</Select.Label>
            <Select.Control>
              <Select.Trigger>
                <Select.ValueText placeholder="Status" />
              </Select.Trigger>
              <Select.IndicatorGroup>
                <Select.ClearTrigger />
                <Select.Indicator />
              </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
              <Select.Positioner>
                <Select.Content>
                  {statuses.items.map((status) => (
                    <Select.Item item={status} key={status.value}>
                      {status.label}
                      <Select.ItemIndicator />
                    </Select.Item>
                  ))}
                </Select.Content>
              </Select.Positioner>
            </Portal>
          </Select.Root>
        </HStack>
      </HStack>
      {isDataLoading ? (
        <WithdrawalSkeleton />
      ) : (
        <>
          <Table.ScrollArea borderWidth="1px" rounded="md" maxHeight="70vh" width="100%">
            <Table.Root interactive variant="outline" stickyHeader>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader width="15%">Name</Table.ColumnHeader>
                  <Table.ColumnHeader width="10%" textAlign="center">
                    Account Id
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="10%" textAlign="center">
                    Amount
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="10%" textAlign="center">
                    Currency
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="10%" textAlign="center">
                    Status
                  </Table.ColumnHeader>

                  <Table.ColumnHeader width="10%" textAlign="center">
                    Withdrawal Method
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="10%" textAlign="center">
                    Withdrawal Date
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="10%" textAlign="center">
                    Action
                  </Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {allWithdrawals?.map((item) => (
                  <Table.Row key={item._id}>
                    <Table.Cell>
                      {item?.user?.fname} {item?.user?.lname}
                    </Table.Cell>
                    <Table.Cell textAlign="center" fontSize="xs">
                      {item?.moneyPlantAccountNo}
                    </Table.Cell>
                    <Table.Cell textAlign="center">{item?.amount}</Table.Cell>
                    <Table.Cell textAlign="center">
                      <Badge variant="surface" colorPalette="teal" size="sm">
                        {item?.user?.currency}
                      </Badge>
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      <Badge
                        variant="surface"
                        colorPalette={
                          item.status === "accepted"
                            ? "green"
                            : item.status === "pending"
                              ? "yellow"
                              : item.status === "rejected" || item.status === "declined"
                                ? "red"
                                : "gray"
                        }
                      >
                        {item.status}
                      </Badge>
                    </Table.Cell>

                    <Table.Cell textAlign="center">
                      <Badge variant="surface" colorPalette="teal" size="sm">
                        {item?.method}
                      </Badge>
                    </Table.Cell>
                    <Table.Cell textAlign="center" fontSize="xs">
                      {formatDateTime(item.createdAt)}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {item?.source === "external" ? (
                        <HStack justifyContent="center">
                          {item.status === "pending" && (
                            <ActionButtonGroup onAction={onExternalAction} isDisabled={isDisabled} data={item._id} />
                          )}
                          <Icon
                            as={FaInfoCircle}
                            size="lg"
                            rounded="full"
                            cursor="pointer"
                            color="gray.500"
                            transition="color 0.1s ease-in-out"
                            _hover={{ color: "gray.700" }}
                            onClick={() => {
                              setTransactionType("external");
                              setModalOpen(true);
                              setModalData(item);
                            }}
                          />
                        </HStack>
                      ) : status === "pending" ? (
                        <ActionButtonGroup onAction={onAction} isDisabled={isDisabled} data={item._id} />
                      ) : (
                        <Icon
                          as={FaInfoCircle}
                          variant="surface"
                          size="lg"
                          rounded="full"
                          cursor="pointer"
                          color="gray.500"
                          transition="color 0.1s ease-in-out"
                          _hover={{ color: "gray.700" }}
                          onClick={() => {
                            setTransactionType(item?.method);
                            setModalOpen(true);
                            setModalData(item);
                          }}
                        />
                      )}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Root>
          </Table.ScrollArea>
          <CustomPagination totalCount={totalPages} current={currentPage} setCurrent={setCurrentPage} />
          {transactionType === "bank" && <BankInfoModal data={modalData} open={modalOpen} setOpen={setModalOpen} />}
          {transactionType === "crypto" && <CryptoInfoModal data={modalData} open={modalOpen} setOpen={setModalOpen} />}
          {transactionType === "external" && <ExternalWithdrawalInfoModal data={modalData} open={modalOpen} setOpen={setModalOpen} />}
        </>
      )}
    </VStack>
  );
};